import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MilitaryTechIcon(props: IconProps) {
    return <Icon {...props} iconKey={"military_tech"}/>
}
